module.exports = __webpack_public_path__ + "static/sm-3-005790e6a007c6a27340737480dcefc9.jpg";